export default "__VITE_ASSET__CyKA0_lj__"